import CoreDrawer from '@/components/CoreDrawer';
import { Spin } from 'antd';
import { get } from 'lodash';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GetDetailWard from '../../viewmodels/ward-detail.viewmodel';
import { WardForm } from './WardForm';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const DetailDistrict = (props: Props) => {
  const { open, setOpen, handleClose } = props;
  const { loadingWard, errorWard, detailWard, actionGetDetail } = GetDetailWard();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open, handleClose, setOpen]);

  useEffect(() => {
    if (showId) {
      actionGetDetail();
    }
  }, [open]);

  const renderContent = () => {
    return (
      <>
        <div>{loadingWard && <Spin />}</div>
        {errorWard && <div>Error</div>}
        {!errorWard && !loadingWard && (
          <WardForm detailWard={get(detailWard, 'data')} openForm={open} />
        )}
      </>
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      content={renderContent()}
      bodyStyle={{ marginTop: '20px' }}
    />
  );
};
